import Vue from 'vue';
import stockTransformer from './../../transformers/stock';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentStock', stockTransformer.fetch(data));
  resolve(stockTransformer.fetch(data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(stockTransformer.fetch(errors));
};

export default (id, stock) => (
  new Promise((resolve, reject) => {
    Vue.$http.put(`/stocks/${id}`, stock)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/stock/update.js